import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import {
  ContactInput,
  ExtendMetricObject,
  FollowedSecurityPolicyOptionsObject,
  VerticalObject,
} from '../../../api/CoachingForm/schema';
import { Feature, isFeatureEnabled } from '../../../config/FeaturesConfig';
import { COACHING_TEXT_LIMIT } from '../../../Util';

export interface FieldTooltips {
  cscContactID?: string;
  vertical?: string;
  followedSecurityPolicies?: string;
  content?: string;
  relatedMetric?: string;
}

const validationSchema = (intl: IntlShape): Yup.ObjectSchema => {
  const messages = {
    followedSecurityPolicies: {
      required: intl.formatMessage({
        id: 'cs_perfportal_contact_review_validate_required_security',
        defaultMessage: 'Security question requires a response',
      }),
    },
    relatedMetric: {
      required: intl.formatMessage({
        id: 'cs_perfportal_contact_review_validate_required_metric',
        defaultMessage: 'Choose the appropriate metric for this contact',
      }),
    },
  };
  return Yup.object<ContactInput>().shape({
    cscContactID: Yup.string().required(
      intl.formatMessage({
        id: 'cs_perfportal_contact_review_validate_required_contact_id',
        defaultMessage: 'Contact ID is required',
      })
    ),
    vertical: Yup.string()
      .nullable()
      .oneOf(
        Object.values(VerticalObject),
        intl.formatMessage({
          id: 'cs_perfportal_contact_review_validate_vertical_required',
          defaultMessage: 'Choose the appropriate vertical for this contact',
        })
      ),
    relatedMetric: Yup.string()
      .nullable()
      .oneOf(Object.keys(ExtendMetricObject()), messages.relatedMetric.required)
      .required(messages.relatedMetric.required),
    followedSecurityPolicies: Yup.string()
      .nullable()
      .required(messages.followedSecurityPolicies.required)
      .oneOf(
        Object.values(FollowedSecurityPolicyOptionsObject),
        messages.followedSecurityPolicies.required
      ),
    content: Yup.string().nullable().default(undefined),
  });
};

export default validationSchema;
